module.exports = __webpack_public_path__ + "img/fp6.3bfd09d0.jpg";